import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-what-we-do5',
  templateUrl: './section-what-we-do5.component.html',
  styleUrls: ['./section-what-we-do5.component.css']
})
export class SectionWhatWeDo5Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
